<template>
  <div
    class="text-element"
    v-on-clickaway="away"
  >
    <div class="top-action" :class="enableActionsButton">
      <b-button-group>
        <b-button class="el-move-action" v-b-popover.hover.left="`Déplacer l'élément`"><font-awesome-icon :icon="['fas', 'expand-arrows-alt']" /></b-button>
<!--        <b-button-->
<!--          @click="openEditElementModal({element: data, elindex})"-->
<!--        >-->
<!--          <font-awesome-icon :icon="['fas', 'edit']" /></b-button>-->
        <b-button
          @click="deleteElement"
          :class="hideTrash"
        ><font-awesome-icon :icon="['fas', 'trash']" /></b-button>
      </b-button-group>
    </div>
    <div class="text-content">
      <!--<span>{{ this.data.value }}</span>-->
      <text-element  :element="data" :elindex="elindex" :elements="elements" :col-index="colIndex" :con-index="conIndex" />
    </div>
<!--    <edit-element-->
<!--      @elementUpdate="handleElementUpdate"-->
<!--      ref="editElement"-->
<!--      />-->
  </div>
</template>

<script>
import editElement from '../modal/editElement'
import textElement from '../display/textElement'
import {eventBus} from '../../../main'
import { directive as onClickaway } from 'vue-clickaway'
import { mapActions } from 'vuex'
export default {
  components: {
    editElement,
    textElement
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    conIndex: Number,
    colIndex: Number,
    elindex: Number,
    elements: Array
  },
  directives: {
    onClickaway: onClickaway
  },
  beforeMount () {
    this.childElements = this.data.childElements
  },
  updated () {
    // this.myData[this.colIndex] = this.newData
    // console.log(this.myData[1])
    // for (var style in this.myData[this.colIndex].style) {
    //     console.log(document.getElementById('text-' + this.conIndex + '-' + this.colIndex))
    //     if (document.getElementById('text-' + this.conIndex + '-' + this.colIndex)) {
    //         document.getElementById('text-' + this.conIndex + '-' + this.colIndex).style[style] = this.myData[this.colIndex].style[style]
    //     }
    // }

    eventBus.$on('elementUpdate', (d) => {
      console.log(d)
      // this.handleElementUpdate(d)
    })
  },
  created () {
    this.myData[this.conIndex] = {}
    this.myData[this.conIndex][this.colIndex] = {}
    this.myData[this.conIndex][this.colIndex][this.elindex] = {}
    this.myData[this.conIndex][this.colIndex][this.elindex] = this.newData

    eventBus.$on('activateTextButton', (data) => {
      // this.enableActionsButton = ''

      if (typeof data !== 'undefined') {
        this.hideTrash = data.hideTrash
      }
    })

    eventBus.$on('applyStyle', (data) => {
      console.log('TEXT')
      var localData = []
      var containerIndex = data.conindex
      var columnIndex = data.colindex
      var elIndex = data.elindex
      // this.myData[containerIndex] = {}
      // this.myData[containerIndex][columnIndex] = {}
      // this.myData[containerIndex][columnIndex][elIndex] = {}
      //
      // this.myData[data.conindex][data.colindex][data.elindex] = data.data

      for (let style in data.data.style) {
        if (document.getElementById('text-' + data.conindex + '-' + data.colindex + '-' + data.elindex)) {
          document.getElementById('text-' + data.conindex + '-' + data.colindex + '-' + data.elindex).style[style] = data.data.style[style]
        }
      }

      this.handleElementUpdate(data)
    })
  },
  data () {
    return {
      text: '',
      isEdit: false,

      enableActionsButton: 'd-none',
      hideTrash: '',
      newData: this.data,
      myData: [],
      myStyle: {}
    }
  },
  methods: {
    ...mapActions(['updateElement']),

    away (e) {
      this.enableActionsButton = 'd-none'

      if (document.querySelector('.temp-deselect')) {
        document.querySelector('.temp-deselect').classList.remove('temp-deselect')
      }

      eventBus.$emit('deactivateTextButton')
    },

    handleElementUpdate (data) {
      this.updateElement(data)
    },
    deleteElement () {
      this.$emit('deleteElement', this.elindex)
    },
    openEditElementModal (data) {
      this.$refs['editElement'].open(data)
    }
  }
}
</script>

<style lang="scss" scoped>
  .text-element{
    /*padding: 4px;*/
    /* margin-bottom: 20px; */
    /*border: 1px solid #2b3085;*/
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    /*background-color: #FFF;*/
    /*text-align: center;*/
    /*font-size: 14px;*/
    .el-move-action{
      cursor: move;
    }
    .top-action {
      position: absolute;
      top: -28px;
      left: 50%;
      height: 25px;
      margin-bottom: 20px;
      text-align: center;
      background-color: #d2d3e5;
      z-index:9999;
      /*width: 100%;*/
      button{
        background-color: transparent;
        border: none;
        color: #2b3085;
        border-radius: 0;
        font-weight: normal;
        box-shadow: none !important;
        padding-left: 5px;
        padding-right: 5px;
        height: 25px;
        line-height: 25px;
        margin-top: -2px;
        &:hover{
          color: #2b3085;
        }
        &:active{
          background-color: #2b3085;
          color: #fff;
        }
      }
    }
    .text-content{
      /*margin-top: 20px;*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/elementText.vue